import Store from './Store';

const B2BPricesStore = new Store('b2b/prices');

export {B2BPricesStore};